import { useMemo } from 'react';
import { useTabsContext } from './Tabs.hooks';
// Custom hook.
// -----------------------------------------------------------------------------
export const useTabContents = (definitions) => {
    // Hooks.
    // ---------------------------------------------------------------------------
    const { selectedTabId } = useTabsContext();
    // Variables.
    // ---------------------------------------------------------------------------
    const tab = useMemo(() => definitions.find(({ id }) => id === selectedTabId), [definitions, selectedTabId]);
    // Return.
    // ---------------------------------------------------------------------------
    return { tab };
};
//# sourceMappingURL=TabsContents.hooks.js.map